import { ArrayUtils, engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Tweens } from "../Components/Effects/Tweens";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { FrameTimerEventEmitter } from "../Utils/FrameTimer";

@engineComponent(ComponentTypes.DisplayObject)
export class AnimatedPaylinePart extends ContainerElement {
    // TODO
    private _status: string = "animate";
    private _winYOffset: number = 6;
    protected originY: number = 0;
    protected originX: number = 0;
    protected _timer: FrameTimerEventEmitter;
    protected _positionOffset: number = 3;
    protected _rotationOffset: number = 3;
    protected _scaleOffset: number = 0.02;
    protected _rotationDuration: number = 240;
    protected _scaleDuration: number = 240;
    protected _scaleDelay: number = 0;
    protected _scaleFirstDelay: number = 0;
    protected _timerRange: Array<number> = [120, 240];
    protected _positionRangeDuration: Array<number> = [360, 540];

    constructor() {
        super();
    }

    public createByNode(node: Element) {
        super.createByNode(node);

        if (node.hasAttribute("WinYOffset")) {
            this._winYOffset = parseInt(node.getAttribute("WinYOffset"));
        }

        this.originY = this.position.y;
        this.originX = this.position.x;

        if (node.hasAttribute("PositionOffset")) {
            this._positionOffset = parseInt(node.getAttribute("PositionOffset"));
        }
        if (node.hasAttribute("RotationOffset")) {
            this._rotationOffset = parseInt(node.getAttribute("RotationOffset"));
        }
        if (node.hasAttribute("ScaleOffset")) {
            this._scaleOffset = parseFloat(node.getAttribute("ScaleOffset"));
        }
        if (node.hasAttribute("RotationDuration")) {
            this._rotationDuration = parseInt(node.getAttribute("RotationDuration"));
        }
        if (node.hasAttribute("ScaleDuration")) {
            this._scaleDuration = parseInt(node.getAttribute("ScaleDuration"));
        }
        if (node.hasAttribute("ScaleDelay")) {
            this._scaleDelay = parseInt(node.getAttribute("ScaleDelay"));
        }

        if (node.hasAttribute("ScaleFirstDelay")) {
            this._scaleFirstDelay = parseInt(node.getAttribute("ScaleFirstDelay"));
        }
        if (node.hasAttribute("TimerRange")) {
            let timerRange: Array<number> = ArrayUtils.numberArray(node.getAttribute("TimerRange"));
            if (timerRange != null && timerRange.length === 2) {
                this._timerRange = timerRange;
            } else {
                if (DEBUG) {
                    this.log("WARNING timer range need to has 2 parameters");
                }
            }
        }
        if (node.hasAttribute("PositionRangeDuration")) {
            let positionRangeDuration: Array<number> = ArrayUtils.numberArray(
                node.getAttribute("PositionRangeDuration"),
            );
            if (positionRangeDuration != null && positionRangeDuration.length === 2) {
                this._positionRangeDuration = positionRangeDuration;
            } else {
                if (DEBUG) {
                    this.log("WARNING position range duration need to has 2 parameters");
                }
            }
        }
    }

    public updateByNode(node: Element) {
        super.updateByNode(node);
    }

    public start(): void {
        // super.start();
    }

    public stop(): void {
        // super.stop();
    }

    public clone(): AnimatedPaylinePart {
        const element: AnimatedPaylinePart = new AnimatedPaylinePart();
        element.style = this.style;
        element.x = this.x;
        element.y = this.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;
        element.childs = {};
        element.removeChildren();
        for (let key in this.childs) {
            element.childs[key] = this.childs[key].clone();
            element.addChild(element.childs[key]);
        }
        let container: PIXI.Container = new PIXI.Container();
        if (element.children != null) {
            while (element.children.length !== 0) {
                container.addChild(element.children[0]);
            }
        }
        element.addChild(container);
        // element._lastY = this._lastY;
        element._winYOffset = this._winYOffset;
        // element._positionOffset = this._positionOffset;
        // element._rotationOffset = this._rotationOffset;
        // element._scaleOffset = this._scaleOffset;
        // element._rotationDuration = this._rotationDuration;
        // element._scaleDuration = this._scaleDuration;
        // element._timerRange = this._timerRange;
        // element._positionRangeDuration = this._positionRangeDuration;
        element.start();
        element.markAsCloned();
        return element;
    }

    public animate(): void {
        let randomRotation: number = Math.round(this.getRandom(-this._rotationOffset - 1, this._rotationOffset + 1));
        if (randomRotation === -1) randomRotation = 1;

        Tweens.removeTweens(this, "rotation");
        if (this.rotation !== 0) {
            Tweens.rotationTween(this, {
                degrees: [this.radians2degrees(this.rotation), 0],
                tweenDuration: 5,
                callbackFunction: (): void => {
                    Tweens.rotationTween(this, {
                        degrees: [this.radians2degrees(this.rotation), randomRotation + 1, 0, -randomRotation - 1, 0],
                        tweenDuration: this._rotationDuration,
                        tweenLoop: true,
                    });
                },
            });
        } else {
            Tweens.rotationTween(this, {
                degrees: [0, randomRotation + 1, 0, -randomRotation - 1, 0],
                tweenDuration: this._rotationDuration,
                tweenLoop: true,
            });
        }

        Tweens.removeTweens(this, "scale");
        if (this.scale.x !== 1 && this.scale.y !== 1) {
            Tweens.scaleTween(this, {
                tweenValues: [new PIXI.Point(this.scale.x, this.scale.y), new PIXI.Point(1, 1)],
                tweenDuration: 5,
                callbackFunction: (): void => {
                    Tweens.scaleTween(this, {
                        tweenValues: [
                            new PIXI.Point(1, 1),
                            new PIXI.Point(1 - this._scaleOffset, 1 + this._scaleOffset),
                            new PIXI.Point(1, 1),
                        ],
                        tweenDuration: this._scaleDuration,
                        tweenLoop: true,
                    });
                },
            });
        } else {
            Tweens.scaleTween(this, {
                tweenValues: [
                    new PIXI.Point(1, 1),
                    new PIXI.Point(1 - this._scaleOffset, 1 + this._scaleOffset),
                    new PIXI.Point(1, 1),
                ],
                tweenDuration: this._scaleDuration,
                tweenLoop: true,
            });
        }
    }

    public animateWin(id: number, scaleOffset: Array<number>, scaleSet: any): void {
        if (this.children.length > 1) {
            let setVisibleObject = Math.round(Math.random() * (this.children.length - 1));
            for (let i = 0; i < this.children.length; i++) {
                if (i == setVisibleObject) {
                    this.childs["Object" + i].visible = true;
                } else {
                    this.childs["Object" + i].visible = false;
                }
            }
        }

        Tweens.removeTweens(this, "scale");
        let randomScale: number = this.getRandom(scaleOffset[0], scaleOffset[1]);
        let randomScaleX: number = Math.round(Math.random()) == 0 ? randomScale : -randomScale;

        if (scaleSet != null) {
            randomScale = scaleSet;
            randomScaleX = scaleSet;
        }

        Tweens.scaleTween(this, {
            tweenValues: [new PIXI.Point(0, 0), new PIXI.Point(randomScaleX, randomScale)],
            tweenDuration: this._scaleDuration,
            tweenEase: "Back.backOut",
            tweenDelay: this._scaleFirstDelay + id * this._scaleDelay,
        });
    }

    public animateFinished(id: number, isLow: boolean): void {
        Tweens.removeTweens(this, "scale");

        let delay: number = isLow ? 60 : 150;

        Tweens.scaleTween(this, {
            tweenValues: [new PIXI.Point(this.scale.x, this.scale.y), new PIXI.Point(0, 0)],
            tweenDuration: this._scaleDuration,
            tweenEase: "Back.backOut",
            tweenDelay: delay,
        });
    }

    public getRandom(min: number, max: number): number {
        return Math.random() * (max - min) + min;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/AnimatedPaylinePart.ts
 **/